var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticStyle:{"color":"#409EFF"},attrs:{"href":"#"},on:{"click":_vm.dataBackfill}},[_vm._v("超链接数据回填案例")])])
}
var staticRenderFns = []

export { render, staticRenderFns }